import script from "./CIIF2026.vue?vue&type=script&setup=true&lang=js"
export * from "./CIIF2026.vue?vue&type=script&setup=true&lang=js"

import "./CIIF2026.vue?vue&type=style&index=0&id=1947348c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1947348c"]])

export default __exports__